<template>
  <q-page padding>

    <!-- <h4 class="text-center text-primary q-my-lg">Step 1 of 2</h4> -->
    <div class="q-pa-md q-gutter-sm text-center">
      <q-avatar size="155px">
        <img v-if="getLine.pictureUrl == ''" src="../assets/profile.png" alt="">
        <img v-else :src="getLine.pictureUrl" alt="">
      </q-avatar>

      <p>{{ getLine.displayName }}</p>
    </div>

    <register-form />

  </q-page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  methods: {
    ...mapActions('auth', ['handleLogin'])
  },
  computed: {
    ...mapGetters('auth', ['getLine', 'getProfile'])
  },
  components: {
    'register-form': require('../components/RegisterForm.vue').default
  },
  mounted () {
    this.handleLogin()
  }

}
</script>

<style lang="scss" scoped>

</style>
